import { RouterProvider } from "@tanstack/react-router";
import React from "react";
import ReactDOM from "react-dom/client";
import "./globals.css";
import { router } from "./router";

async function enableDevtools() {
  // if (import.meta.env.DEV) {
  //   const { TanStackRouterDevtools } = await import(
  //     "@tanstack/react-router-devtools"
  //   );
  //   return (
  //     <TanStackRouterDevtools
  //       router={router}
  //       toggleButtonProps={{ style: { bottom: 40, right: 16 } }}
  //     />
  //   );
  // }
  return null;
}

const rootEl = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootEl);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

enableDevtools().then((devtools) => {
  if (devtools) {
    root.render(
      <React.StrictMode>
        <RouterProvider router={router} />
        {devtools}
      </React.StrictMode>
    );
  }
});
